import { render, staticRenderFns } from "./tiyouyouAddLive.vue?vue&type=template&id=1b604799&"
import script from "./tiyouyouAddLive.vue?vue&type=script&lang=js&"
export * from "./tiyouyouAddLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports